export const AI_CHAT_CONTEXT_GUARD_BANDS = ['fresh', 'advisory', 'approaching', 'blocked'] as const;
export type AIChatContextGuardBand = typeof AI_CHAT_CONTEXT_GUARD_BANDS[number];

export interface AIChatContextGuardStatus {
    schemaVersion: 1;
    band: AIChatContextGuardBand;
    contextTokens: number;
    hardLimitTokens: number;
    measuredAt: string;
    source: 'provider-step-usage';
}

export const AI_CHAT_CONTEXT_GUARD_METADATA_KEY = 'workbuddyContextGuard';
export const AI_CHAT_CONTEXT_LIMIT_REACHED_CODE = 'CHAT_CONTEXT_LIMIT_REACHED';

export function isAIChatContextGuardStatus(value: unknown): value is AIChatContextGuardStatus {

    if (!value || typeof value !== 'object') return false;
    const status = value as Partial<AIChatContextGuardStatus>;
    return status.schemaVersion === 1
        && AI_CHAT_CONTEXT_GUARD_BANDS.some(band => band === status.band)
        && typeof status.contextTokens === 'number'
        && Number.isFinite(status.contextTokens)
        && typeof status.hardLimitTokens === 'number'
        && Number.isFinite(status.hardLimitTokens)
        && typeof status.measuredAt === 'string'
        && status.source === 'provider-step-usage';
}
